import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link, useWindowDimensions } from '@sentecacommerce-theme/lib'
import { FooterMenuItem } from '../../footer.props'
import { Collapse, IconPlus, Typography, IconMinus } from '../../../Common'
import { SubMenu } from '../SubMenu'

export const Menu = (props: FooterMenuItem) => {
  const { label, items, footerImageLinks, contentMaxWidthOnLarge, additionalImages } = props
  const { width } = useWindowDimensions()
  const [expanded, setExpanded] = useState(true)

  const toggleMenu = () => {
    setExpanded((value) => !value)
  }
  const renderFooterImageLinks = props?.footerImageLinks

  useEffect(() => {
    if (width <= 992) {
      setExpanded(false)
      return
    }
    setExpanded(true)
  }, [])
  return (
    <Container>
      <TitleContainer onClick={toggleMenu}>
        <Title>{label}</Title>
        <IconWrapper expanded={expanded}>
          {expanded ? <IconMinus /> : <IconPlus />}
        </IconWrapper>
      </TitleContainer>
      <Collapse expanded={expanded}>
        <SubMenuContainer expanded={expanded}>
          {renderFooterImageLinks && (
            <ImageLinkContainers>
              {footerImageLinks?.map((imgLink) => (
                <Link
                  href={imgLink?.url || '#'}
                  passHref
                  key={`Img__${imgLink}`}
                >
                  <ImageLink>
                    <Figure>
                      <img src={imgLink?.image} alt={imgLink?.caption || 'Hipoland'} loading="lazy" />
                      {imgLink?.caption && (
                        <FigCaption>{imgLink?.caption}</FigCaption>
                      )}
                    </Figure>
                  </ImageLink>
                </Link>
              ))}
            </ImageLinkContainers>
          )}
          <SubMenu items={items} contentMaxWidth={contentMaxWidthOnLarge} />
          {additionalImages?.map((img) => (
              <Link 
                href={img?.url || '#'}
                passHref
                key={`Image__${img.image}`}
              >
                <Wrapper>
                  <AdditionalImage src={img?.image} alt="Hippoland" />
                  {img?.caption && (
                    <FigCaption>{img?.caption}</FigCaption>
                  )}
                </Wrapper>
              </Link>
          ))}
        </SubMenuContainer>
      </Collapse>
    </Container>
  )
}

const Container = styled(Typography).attrs({
  as: 'div',
  variant: '4',
})`
  line-height: 2.6rem;
  position: relative;
  font-weight: 300;
  letter-spacing: 0.06rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    font-size: 1.4rem;
    line-height: 1.7rem;
  }
`

const Figure = styled.figure.attrs({
  className: 'd-flex flex-column align-items-center mr-3 flex-lg-row',
})``

const FigCaption = styled.figcaption.attrs({
  className: 'ml-lg-2',
})`
  font-size: 1.6rem;
  color: ${({ theme }) => theme.palette.silverTree};
`

const Title = styled.p`
  line-height: inherit;
  font-size: inherit;
  cursor: pointer;
  font-weight: 600;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    font-size: 1.6rem;
  }
`

const SubMenuContainer = styled.div.attrs({
  className: 'px-4 px-lg-0',
})<{ expanded?: boolean }>`
  position: relative;
  top: ${(props) => (props.expanded ? '0' : '-2rem')};
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  transition: top 0.8s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  border-bottom: 0.1rem solid #e5e5e5;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    border: 0;
  }
`

const TitleContainer = styled.div.attrs({
  className: 'px-4 px-lg-0',
})`
  padding-top: 2rem;
  padding-bottom: 2rem;
  border-bottom: 0.1rem solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    border: 0;
    padding-top: 0;
    padding-bottom: 0.8rem;
    pointer-events: none;
  }
`

const IconWrapper = styled.div.attrs({
  className: 'd-lg-none',
})<{ expanded?: boolean }>`
  width: 2rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 100%;
    height: auto;
  }
`

const ImageLinkContainers = styled.div.attrs({
  className: 'd-flex',
})``

const ImageLink = styled.a.attrs({
  className: '',
})`
  width: auto;
  text-align: left;
  display: block;
  padding-top: 2rem;

  display: flex;
  align-items: center;

  & img {
    width: 100%;
    max-width: 5.5rem;
    height: auto;
  }

  &:not(:last-child) {
    margin-right: 1rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    text-align: left;
    padding-top: 1.3rem;
  }
`

const AdditionalImage = styled.img.attrs({
  className: 'pt-lg-4 pb-3',
})`
  max-width: 5rem;
  margin-left: -0.2rem;
  height: auto;
  cursor: pointer;
`

const Wrapper = styled.div.attrs({
  className: 'd-flex flex-column align-items-left',
})``